/*
* @Author: Joana 'dygon' Oliveira
* @Date:   2021-09-17 10:43:36
* @Last Modified by:   Joana 'dygon' Oliveira
* @Last Modified time: 2021-09-17 10:54:46
*/
jQuery.noConflict();